import React, { useEffect, useState, useRef } from 'react';
import { Typography } from '../../index';
import './content_switcher.scss';

export const ContentSwitcher = ({
    defaultIndex = 0,
    fluid,
    onChange,
    size = "sm",
    options,
}) => {
    const [selectedIndex, setSelectedIndex] = useState(defaultIndex);
    const [btnMinWidth, setBtnMinWidth] = useState();
    const contentSwitcherEl = useRef();

    useEffect(() => {
        if (!fluid) {
            let btnWidth = 0;
            if (contentSwitcherEl.current) {
                for (let i = 0; i < contentSwitcherEl.current.children.length; i++) {
                    if (contentSwitcherEl.current.children[i].children[0]) {
                        let elWidth = contentSwitcherEl.current.children[i].children[0].clientWidth;

                        if (elWidth > btnWidth) {
                            btnWidth = elWidth;
                        }
                    }
                }
            }
            if (size === 'sm') {
                if (options.length < 3) {
                    if (btnWidth < 76) {
                        btnWidth = 76;
                    }
                } else {
                    if (btnWidth < 66) {
                        btnWidth = 66;
                    }
                }
            } else if (size === 'lg') {
                if (options.length < 3) {
                    if (btnWidth < 110) {
                        btnWidth = 110;
                    }
                } else if (options.length === 3) {
                    if (btnWidth < 76) {
                        btnWidth = 76;
                    }
                } else {
                    if (btnWidth < 66) {
                        btnWidth = 66;
                    }
                }
            }

            setBtnMinWidth(btnWidth);
            if (options.length < (selectedIndex + 1)) {
                setSelectedIndex(0);
            }
        }
    }, [options]);

    useEffect(() => {
        if (defaultIndex !== selectedIndex) {
            setSelectedIndex(defaultIndex);
        }
    }, [defaultIndex]);

    const sliderClasses = [
        `bsw-content-switcher`,
        `bsw-content-switcher--${size}`,
        `bsw-content-switcher--${size}-${options.length}`,
        `bsw-content-switcher--${fluid ? 'fluid' : 'inline'}`
    ].join(' ');

    const setBtnClasses = (index) => {
        return `bsw-content-switcher__btn ${selectedIndex === index ? 'bsw-content-switcher__btn--active' : ''}`
    };

    const handleOnClick = (e, item, index) => {
        setSelectedIndex(index);
        onChange(item, index);
    }

    const btnStyles = { minWidth: `${btnMinWidth ? btnMinWidth + 'px' : ''}`, width: `${100 / options.length}%` };
    const sliderStyles = { minWidth: `${btnMinWidth ? btnMinWidth + 'px' : ''}`, width: `${100 / options.length}%`, transform: `translateX(${100 * selectedIndex}%)` };
    const renderOptions = (item, index) => {
        return (
            <button
                key={index}
                className={setBtnClasses(index)}
                onClick={(event) => handleOnClick(event, item, index)}
                style={btnStyles}
                type='button'
            >
                <Typography
                    textAlign="center"
                    tag="div"
                    type="body-01"
                    color={`${selectedIndex === index ? '$color-primary-c1' : ''}`}
                >
                    {item}
                </Typography>
            </button>)
    }

    return (
        <div className={sliderClasses}>
            <div className='bsw-content-switcher__options' ref={contentSwitcherEl}>
                <div className="selector" style={sliderStyles}></div>
                {options.map((item, index) => renderOptions(item, index))}
            </div>
        </div>
        )
}
